import React, { useState } from 'react';
import { shallow } from 'zustand/shallow';
import { CollapsibleBase } from '@rivallapp/volosports-components';

import { useUrlParams } from '../../../../../hooks';
import { useDiscoverStore } from '../../../../../zustand-stores';
// import { Collapsible } from '../../../../../shared-components/base-components';
import { NumberOfPeopleFilter } from '../../../../../shared-components/feature-components';
import { MainTabEnum, SubTabEnum } from '../../../../../shared/discover-tabs-enum';

const DiscoverNumberOfPeopleFilter = () => {
  const { updateUrlParams } = useUrlParams();

  const { view, subView, minimumMen, minimumWomen, minimumNonBinary } = useDiscoverStore(
    store => ({
      view: store.view,
      subView: store.subView,
      minimumMen: store.filters.minimumMen,
      minimumWomen: store.filters.minimumWomen,
      minimumNonBinary: store.filters.minimumNonBinary,
    }),
    shallow
  );

  const [collapsed, setCollapsed] = useState(!minimumMen && !minimumWomen && !minimumNonBinary);
  const handlePress = () => setCollapsed(!collapsed);

  // const isCollapsed = !minimumMen && !minimumWomen && !minimumNonBinary;

  // Only show filter on Sports -> Daily tab
  if (view !== MainTabEnum.SPORTS || subView !== SubTabEnum.DAILY) {
    return null;
  }

  return (
    <CollapsibleBase title="Number of People" isCollapsed={collapsed} onPress={handlePress}>
      <NumberOfPeopleFilter
        style={{ marginHorizontal: 15 }}
        minimumMen={minimumMen}
        minimumWomen={minimumWomen}
        minimumNonBinary={minimumNonBinary}
        onChangeMinimumMen={value => updateUrlParams({ minimumMen: value || undefined })}
        onChangeMinimumWomen={value => updateUrlParams({ minimumWomen: value || undefined })}
        onChangeMinimumNonBinary={value =>
          updateUrlParams({ minimumNonBinary: value || undefined })
        }
      />
    </CollapsibleBase>
  );
};

export default DiscoverNumberOfPeopleFilter;
